'use strict';
/**
 * Created by caimingxun on 2016/10/28.
 */
import keyMirror from 'keymirror';

export const drama = keyMirror({
  FETCH_DRAMA_SUMMARY: null,
  FETCH_DRAMA_SUMMARY_SUCCESS: null,
  FETCH_DRAMA_SUMMARY_FAILED: null,

  FETCH_DRAMAINFO: null,
  FETCH_DRAMAINFO_SUCCESS: null,
  FETCH_DRAMAINFO_FAILED: null,

  FETCH_DRAMA_PINNED_COMMENTS: null,
  FETCH_DRAMA_PINNED_COMMENTS_SUCCESS: null,
  FETCH_DRAMA_PINNED_COMMENTS_FAILED: null,

  FETCH_DRAMA_COMMENTS: null,
  FETCH_DRAMA_COMMENTS_SUCCESS: null,
  FETCH_DRAMA_COMMENTS_FAILED: null,
  POST_DRAMA_COMMENT: null,
  POST_DRAMA_COMMENT_SUCCESS: null,
  POST_DRAMA_COMMENT_FAILED: null,
  DELETE_DRAMA_COMMENT: null,
  DELETE_DRAMA_COMMENT_SUCCESS: null,
  DELETE_DRAMA_COMMENT_FAILED: null,
  CLEAN_COMMENTS: null,

  FETCH_DRAMA_REPLIES: null,
  FETCH_DRAMA_REPLIES_SUCCESS: null,
  FETCH_DRAMA_REPLIES_FAILED: null,
  POST_DRAMA_REPLY: null,
  POST_DRAMA_REPLY_SUCCESS: null,
  POST_DRAMA_REPLY_FAILED: null,
  DELETE_DRAMA_REPLY: null,
  DELETE_DRAMA_REPLY_SUCCESS: null,
  DELETE_DRAMA_REPLY_FAILED: null,

  FETCH_DRAMA_CATEGORY: null,
  FETCH_DRAMA_CATEGORY_SUCCESS: null,
  FETCH_DRAMA_CATEGORY_FAILED: null,
});

export const seo = keyMirror({
  FETCH_DRAMA_SEO_INFO: null,
});

export const device = keyMirror({
  CHECK_IPAD_OS: null,
});

export * from './user';
